import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';

import {SiteConfig} from '@app/shared/site-config.service';

@Component({
    selector: 'frog-workspace-button',
    templateUrl: './workspace-button.component.html',
    styleUrls: ['./workspace-button.component.scss'],
    imports: [MatButton, MatTooltip],
})
export class WorkspaceButtonComponent implements OnInit {
    @Input() siteConfig: SiteConfig;
    @Output() clicked: EventEmitter<string>;

    constructor() {
        this.clicked = new EventEmitter<string>();
    }

    ngOnInit(): void {}

    clickHandler(client: string) {
        this.clicked.emit(client);
    }
}
